import styles from './default-card.module.scss';
import ReadMoreButton from '../read-more-button';

const ArticleCardSimple = ({ title, readMoreUrl }) => {
	return (
		<div className={styles.container}>
			<div className={styles.desktopSecondColumn}>
				<h2 className={styles.title}>{title}</h2>
				<div className={styles.flex}>
					<div className={styles.desktopContentContainer}>
						<div className={styles.desktopReadMoreContainer}>
							<ReadMoreButton
								textColor={'black'}
								url={readMoreUrl}
								text="Läs mer"
								className={styles.readMore}
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ArticleCardSimple;
